/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable max-len */
import React, { useState, useCallback, useEffect, useContext } from 'react'
import { motion } from 'framer-motion';
import moment from 'moment'
import { distributorService } from '../../service/distributor.service'
import FilterModal from './filterModal'
import {PriceHandler} from '../../redux/helper/CamelCase';
import Pagination from '../../Components/Pagination';
import EmptyOrderPage from '../MyOrders/EmptyOrderPage';
import OrderListingSkeleton from '../MyOrders/OrderListingSkeleton';
import { GenerateDateandTime, GenerateDateFormat, generateDateWithTime } from '../../redux/helper/DateConverter'
import HeaderContext from '../../Components/Context/HeaderContext';
import { Link } from 'react-router-dom';


const Transactionlist = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [filterModal, setfilterModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [query, setQuery] = useState({'limit':10, 'page':1, sort: 'created_at+asc'})
    const [transactions, setTransactions] = useState([])
    const [opening_balance, setOpeningBalance] = useState(0)
    const [freezed, setFreezed] = useState(0)
    const [dateselected, setdateselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    
    const handleTransactions = useCallback(
        async (query1) => {
            const serachparam = new URLSearchParams(query1);
            const response = await distributorService.AdorCashTransaction(serachparam.toString())
            setEmptyData(false)
            if(response.data.success_status === true){
                
                if (response.data.data.url){
                    SetSuccessMessage('Exported successfully');
                    setexportClick(false);
                    setexportSelected('');
                    delete query.export;
                    window.open(response.data.data.url, '_blank');
                    setTimeout(() => {
                        SetSuccessMessage('');
                    }, 2000);
                }
                else{
                    setLoading(false)
                    setTransactions(response.data.data.Items)
                    setOpeningBalance(response.data.data.opening_balance_num)
                    setFreezed(response.data.data.freezzed)
                    setalldata(response);
                    setCurrentPage(response.data.data.current_page);
                    setTotalPage(response.data.data.number_of_pages);
                    if (response.data.data.Items.length === 0 ) setEmptyData(true)  
                }                
            }
        },[]);
    
    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        query.page = page;
        setQuery(query)
        setCurrentPage(page);
        handleTransactions(query)
    };

    useEffect(() => {
        handleTransactions(query)
    }, []);

    return (
        <div>
            {loading ? <OrderListingSkeleton /> : (
                <div className="sm:mx-10 mx-5">
                    <p className="my-3 text-[#090406] font-semibold text-sm26">Ador Cash Transaction History</p>
                    <div className="flex sm:items-center items-start sm:justify-between justify-start  sm:flex-row flex-col">
                        <div className="flex items-center justify-center sm:mb-3 mb-5 sm:mr-0 mr-2">
                            <p className=" font-semibold sm:text-xs27 text-xs25 border h-[50px] flex w-fit items-center justify-center md:px-10 px-5 border-[#555259] bg-[#F5F5FA] text-[#090406] rounded-xl">Ador Cash Balance : <span className="font-normal text-[#090406] sm:text-xs28 text-xs25 pl-2">  {PriceHandler(opening_balance)}</span></p>
                            <Link to={`/orders?freezed_ador_cash=true`}>
                                <p className=" font-semibold sm:text-xs27 text-xs25 border h-[50px] flex w-fit items-center justify-center md:px-10 px-5 border-[#555259] bg-[#F5F5FA] text-[#090406] rounded-xl">Ador Cash Freezed : <span className="font-normal text-[#090406] sm:text-xs28 text-xs25 pl-2">  {PriceHandler(freezed)}</span></p>
                            </Link>
                        </div>
                       
                        <div className="sm:mb-0 mb-3">
                            <div className="flex sm:mx-2 mx-0 md:justify-end justify-strat items-center w-full">
                                <button type="button" className="flex items-center bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-5 rounded-[9px]" 
                                    style={{
                                        border: '2px solid #E9EDF4',
                                    }} 
                                    data-bs-toggle="modal" data-bs-target="#filtermodal"
                                    onClick={() => setfilterModal(true)}
                                >
                                    {(query.hasOwnProperty('transaction_type') || query.hasOwnProperty('type') || query.hasOwnProperty('created_range')) ? <span className='mr-1'><img src="/images/red-button.png"></img></span> : ''}Filter
                                </button>
                                <div className="pl-2 dropdown relative">
                                    <button 
                                        type="button" 
                                        id="exportDropdown" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false" 
                                        className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] lg:px-7 px-4 border border-[#555259] rounded-lg"
                                        onClick={()=>setexportClick(!exportClick)} 
                                    >
                                        Export
                                    </button>
                                    <ul className={`dropdown-menu min-w-[94px] ${exportClick ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9]`} style={{zIndex: '9'}} aria-labelledby="exportDropdown">
                                        <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                            <a 
                                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"  
                                                href="#"
                                                onClick={() => {
                                                    query.export='csv'
                                                    handleTransactions(query)
                                                }}
                                            >CSV</a>
                                        </li>
                                        <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                            <a 
                                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5" 
                                                href="#"
                                                onClick={() => {
                                                    query.export='pdf'
                                                    handleTransactions(query)
                                                }}
                                            >PDF</a>
                                        </li>
                                        <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                            <a 
                                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5" 
                                                href="#"
                                                onClick={() => {
                                                    query.export='excel'
                                                    handleTransactions(query)
                                                }}
                                            >Excel</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                                    <input type="text" className="lg:w-[180px] w-[140px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" placeholder="Search" onInput={(e)=>{
                                        e.target.value == ''? delete query.search : query.search = e.target.value
                                        setQuery(query)
                                        handleTransactions(query)
                                    }}/>
                                    <img src="images/search-box.svg" alt="icon" className="absolute top-1.5 right-1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overflow-auto dropdown-menu pb-7 relative" style={{height: 'calc(100vh - 325px)', zIndex: '6'}}>
                        <table className="w-full table-auto relative">
                            <thead className='sticky top-0 left-0 z-[1]'>
                                <tr className="bg-[#555259] h">
                                    <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[200px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                        <span className="text-xs5 font-bold text-[#FFFFFF]">
                                            Transaction Type
                                        </span>
                                    </th>
                                    <th scope="col" className="py-2.5 px-7 min-w-[145px]">
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                            Type
                                        </span>
                                    </th>
                                    <th scope="col" className="py-2.5 px-7 min-w-[180px]">
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                            Transaction No.
                                        </span>
                                    </th>
                                    <th scope="col" className="py-2.5 px-7 min-w-[200px] text-center flex justify-center items-center pt-4" onClick={()=>{
                                        if (query.sort.includes('transaction_date+asc')){
                                            query.sort = 'transaction_date+desc'
                                        }else{
                                            query.sort = 'transaction_date+asc'
                                        }
                                        setQuery(query)
                                        handleTransactions(query)
                                    }}>
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                            Transaction Date
                                            <a href="#" className="pl-[5px]">
                                                <motion.img 
                                                    animate={{ rotate: (query.sort.includes('transaction_date+asc')) ? 180 : 0 }}
                                                    className={`${(query.sort.includes('transaction_date+asc')) ? 'image-rotate' : ''}`}
                                                    src="/images/sort.svg" 
                                                    alt="icon"
                                                />
                                            </a>
                                        </span>
                                    </th>
                                    <th scope="col" className="py-2.5 px-7 min-w-[250px]">
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                            Ador Cash Redeemed
                                        </span>
                                    </th>
                                    <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                            Ador Cash Received
                                        </span>
                                    </th>
                                    <th scope="col" className="py-2.5 px-7 min-w-[220px]" onClick={()=>{
                                        if (query.sort.includes('created_at+asc')){
                                            query.sort = 'created_at+desc'
                                        }else{
                                            query.sort = 'created_at+asc'
                                        }
                                        setQuery(query)
                                        handleTransactions(query)
                                    }}>
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                            Ador Cash Txn. Date
                                            <a href="javascript:void(0)" className="pl-[5px]">
                                                <motion.img 
                                                    animate={{ rotate: (query.sort.includes('created_at+desc')) ? 180 : 0 }}
                                                    className={`${(query.sort.includes('created_at+asc')) ? 'image-rotate' : ''}`}
                                                    src="/images/sort.svg" 
                                                    alt="icon"
                                                />
                                            </a>
                                        </span>
                                    </th> 
                                    <th scope="col" className="py-2.5 px-7 min-w-[340px] rounded-br-lg rounded-tr-lg">
                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                            Comment
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.length > 0 && transactions.map((item,index) => (
                                    <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={`ador-cash-${index}`}>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4" style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                            {item.transaction_type}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                            {item.type}                       
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                            {item.transaction_number}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                            {generateDateWithTime(item.transaction_date)}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                            {item.amount < 0? PriceHandler(item.amount*-1) : '-'}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                            {item.amount >= 0? PriceHandler(item.amount) : '-'}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                            {moment(item.created_at).format('DD-MMM-YYYY, HH:mm:ss')}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-start">
                                            {item.comment}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {emptyData && <EmptyOrderPage search="yes" text="no ador cash transactions" all={query.search !== undefined ? 'under searched term' : 'found'} />}
                    </div>
                    {transactions && transactions.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {filterModal && <FilterModal 
                        filterModal={filterModal}
                        setfilterModal={setfilterModal}
                        query={query}
                        setQuery={setQuery}
                        handleTransactions={handleTransactions}
                        dateselected={dateselected}
                        setdateselected={setdateselected}
                        SetSuccessMessage={SetSuccessMessage}
                    />}
                </div>
            )}
        </div>
       
    )
}

export default Transactionlist
